import { useEffect } from "react";
import FormComponent from "../components/FormComponent";

function Banner() {
  useEffect(() => {
    const setBannerBackground = () => {
      const banner = document.getElementById("banner");
      if (!banner) return;

      banner.classList.add("bg-banner");

      if (window.innerWidth < 768) {
        banner.style.backgroundImage = "url('dist/img/banner_bg_mobile.webp')";
      } else {
        banner.style.backgroundImage = "url('dist/img/banner_bg.webp')";
      }
    };

    const handleReady = () => {
      requestAnimationFrame(() => {
        setBannerBackground();
        document.body.classList.add("bg-loaded");
      });
    };

    // initial load
    if (
      document.readyState === "interactive" ||
      document.readyState === "complete"
    ) {
      handleReady();
    } else {
      document.addEventListener("DOMContentLoaded", handleReady);
    }

    // add resize listener
    window.addEventListener("resize", setBannerBackground);

    // cleanup
    return () => {
      document.removeEventListener("DOMContentLoaded", handleReady);
      window.removeEventListener("resize", setBannerBackground);
    };
  }, []);

  return (
    <section id="banner" className="position-relative">
      <div className="container-lg px-3 p-lg-0">
        <div className="row g-0 justify-content-between">
          <div className="col-md-7 col-xl-7 position-relative z-3 banner-wrapper">
            <div className="bannerlist mt-3 px-lg-0">
              <h1>
                Maximise your savings, <br className="" />
                minimise your EMIs. Transfer <br className="" />
                your Home Loan to ICICI Bank
              </h1>
              <div className="features mt-4 mb-5 mt-md-5 mt-mb-0">
                <div className="d-flex gap-5 feat align-items-center">
                  <img
                    src="dist/img/banner01.svg"
                    alt="icon"
                    width={45}
                    height={45}
                  />
                  <p>
                    Topup facility <br /> Available
                  </p>
                </div>
                <div className="d-flex gap-5 feat align-items-center">
                  <img
                    src="dist/img/banner02.svg"
                    alt="icon"
                    width={45}
                    height={45}
                  />
                  <p>
                    Instant provisional <br /> sanction*
                  </p>
                </div>
                <div className="d-flex gap-5 feat align-items-center">
                  <img
                    src="dist/img/banner03.svg"
                    alt="icon"
                    width={45}
                    height={45}
                  />
                  <p>Flexible Tenure</p>
                </div>
              </div>
            </div>
            <p className="tnc">
              *T&Cs. Provisional sanction is subject <br />
              to due diligence done by Bank.
            </p>
          </div>
          <div className="col-lg-5 col-xl-4 mt-2 mt-mb-0">
            <FormComponent></FormComponent>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
